import {createTheme} from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        background: {
            default: '#fafafa',
            paper: '#ffffff',
        },
        primary: {
            main: '#3f51b5',
        },
        actionItem: {
            main: '#0076FFFF',
        },
        statusActive: {
            main: '#3ed436',
        },
        statusPaused: {
            main: '#f6ab2e',
        },
        statusNew: {
            main: '#f6ab2e',
        },
        statusRemoved: {
            main: '#D47483',
        },
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiTextField: {
            defaultProps: {
                variant: 'standard',
            },
        },
        MuiSelect: {
            defaultProps: {
                variant: 'standard',
            },
        },
        MuiInputBase: {
            defaultProps: {
                disableInjectingGlobalStyles: true,
            },
        },
        MuiDatePicker: {
            defaultProps: {
                slotProps: {
                    textField: {
                        variant: 'standard',
                        readOnly: true,
                    },
                },
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    backgroundColor: '#fff',
                },
                columnHeader: {
                    'backgroundColor': '#fff',
                    '&:focus': {
                        outline: 'none',
                    },
                    '&:focus-within': {
                        outline: 'none',
                    },
                },
                footerContainer: {
                    backgroundColor: '#fff',

                },
                cell: {
                    '&:focus': {
                        outline: 'none',
                    },
                    '&:focus-within': {
                        outline: 'none',
                    },
                },
            },
        },
    },
});

